import { render, staticRenderFns } from "./topic-resource.vue?vue&type=template&id=afadc990&scoped=true"
import script from "./topic-resource.vue?vue&type=script&lang=js"
export * from "./topic-resource.vue?vue&type=script&lang=js"
import style0 from "./topic-resource.vue?vue&type=style&index=0&id=afadc990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afadc990",
  null
  
)

export default component.exports